module.exports = __webpack_public_path__ + "static/media/qr_code.3a99ce57.png";